import { render, staticRenderFns } from "./CustomerSpecificPrices.vue?vue&type=template&id=44d1d76d"
import script from "./CustomerSpecificPrices.vue?vue&type=script&lang=js"
export * from "./CustomerSpecificPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports